import { controlToastState } from "risa-oasis-ui_v2";
import { PushToSftpTableDataModel } from "../../../../data-model/pushToSftpDataModel";
import { PushToSftpModalTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { closeModal } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";
import { logError } from "../../../../utils/customLogger";

/**
 * Handler for Text Note Click action
 * This is called when the modal is in 'textNote' mode
 */
export const onTextNoteClick = (
  tableData: PushToSftpTableDataModel[],
  dispatch: AppDispatch,
  runTextNote: (...args: any[]) => Promise<any>,
): { promise: Promise<void> } => {
  const selectedData = tableData.filter(
    (item) => item[PushToSftpModalTableColumnKeys.SELECT]?.isChecked,
  );

  if (selectedData.length === 0) {
    controlToastState("text-note-no-selection");
    return {
      promise: Promise.resolve(),
    };
  }

  const selectedFilenames = selectedData
    .map((item) => item[PushToSftpModalTableColumnKeys.FILENAME])
    .filter((filename): filename is string => filename !== undefined);

  if (selectedFilenames.length === 0) {
    controlToastState("text-note-no-selection");
    return {
      promise: Promise.resolve(),
    };
  }

  runTextNote(selectedFilenames).catch(() => {
    controlToastState("text-note-error");
    logError(new Error("Error sending text note"), "Error sending text note");
  });

  const promise = new Promise<void>((resolve) => {
    setTimeout(() => {
      controlToastState("text-note-success");
      dispatch(closeModal());
      resolve(undefined);
    }, 5000);
  });

  return { promise };
};
